"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incrementUiValue = exports.convertIncrementToIntDecimalPlaces = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Converts Price/Quantity Increment to expected (int) decimalPlaces.
 *  i.e., Xe-8 => 8.
 * @param {number} increment
 */
var convertIncrementToIntDecimalPlaces = exports.convertIncrementToIntDecimalPlaces = function convertIncrementToIntDecimalPlaces(increment) {
  if (!increment || increment >= 1) return 0;
  return parseFloat(increment.toExponential().split('-')[1]);
};

/**
 * Ensure value is in units of increment.
 * Better name: "roundDownToNearestIncrement"
 *
 * @param {number} val
 * @param {number} increment
 */
var incrementUiValue = exports.incrementUiValue = function incrementUiValue(val, increment) {
  var A = new _bignumber["default"](val);
  var B = new _bignumber["default"](increment);
  return A.minus(A.modulo(B));
};